// extracted by mini-css-extract-plugin
export default {"block":"Like_block__5Pqyr","heart":"Like_heart__tupBg"};